import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import templateDownload from '../../../assets/templateDownload.png';
import uploadAndSubmit from '../../../assets/uploadAndSubmit.png';
import uploadReturnOrderNavigation from '../../../assets/uploadReturnOrderNavigation.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpAlert, HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpTitle } from './HelpElements';

const UploadReturnOrderHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('uploadReturnOrderHelp');

    return (
        <>
            <HelpTitle>{t('uploadReturnOrderHelp_Title')}</HelpTitle>
            <HelpBody>{t('uploadReturnOrderHelp_purpose')}</HelpBody>
            <HelpStep step={1}>
                <Trans
                    i18nKey={'uploadReturnOrderHelp_navigateToUploadReturnOrder'}
                    ns={'uploadReturnOrderHelp'}
                    components={{ url: <Link href={'https://reseller.amazon.com'}>{''}</Link> }}
                />
            </HelpStep>
            <HelpImage src={uploadReturnOrderNavigation} />
            <HelpStep step={2}>{t('uploadReturnOrderHelp_downloadTemplate')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('uploadReturnOrderHelp_templateBuyback')}</HelpBullet>
                <HelpBullet>{t('uploadReturnOrderHelp_templateRefusal')}</HelpBullet>
                <HelpBullet>{t('uploadReturnOrderHelp_templateReturns')}</HelpBullet>
            </HelpIndent>
            <HelpImage src={templateDownload} />
            <HelpStep step={3}>{t('uploadReturnOrderHelp_enterHeaderData')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('uploadReturnOrderHelp_inputReferenceId')}</HelpBullet>
                <HelpBullet>{t('uploadReturnOrderHelp_contactEmails')}</HelpBullet>
                <HelpBullet>{t('uploadReturnOrderHelp_locationCodes')}</HelpBullet>
            </HelpIndent>
            <HelpStep step={4}>{t('uploadReturnOrderHelp_enterLineItems')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('uploadReturnOrderHelp_selectAction')}</HelpBullet>
                <HelpIndent>
                    <HelpBullet level={1}>{t('uploadReturnOrderHelp_actionAccept')}</HelpBullet>
                    <HelpBullet level={1}>{t('uploadReturnOrderHelp_actionEligible')}</HelpBullet>
                </HelpIndent>
            </HelpIndent>
            <HelpStep step={5}>{t('uploadReturnOrderHelp_saveFile')}</HelpStep>
            <HelpImage src={uploadAndSubmit} />
            <HelpStep step={6}>{t('uploadReturnOrderHelp_editDraft')}</HelpStep>
            <HelpAlert>{t('uploadReturnOrderHelp_troubleshooting')}</HelpAlert>
        </>
    );
};

export { UploadReturnOrderHelp };
